import { COREUI_DEVICE_ICON_MAPPING, ICON_MAPPING } from './icons'
// import * as battery0 from '@/../images/device_icons/geoenergy/battery0.svg'
// import * as battery20 from '@/../images/device_icons/geoenergy/battery20.svg'
// import * as battery40 from '@/../images/device_icons/geoenergy/battery40.svg'
// import * as battery60 from '@/../images/device_icons/geoenergy/battery60.svg'
// import * as battery80 from '@/../images/device_icons/geoenergy/battery80.svg'
// import * as battery100 from '@/../images/device_icons/geoenergy/battery100.svg'
import * as chp from '@/../images/device_icons/geoenergy/chp.svg'
// import * as container from '@/../images/device_icons/geoenergy/container.svg'
// import * as containerAlarm from '@/../images/device_icons/geoenergy/container_alarm.svg'
// import * as containerOk from '@/../images/device_icons/geoenergy/container_ok.svg'
// import * as containerWarning from '@/../images/device_icons/geoenergy/container_warning.svg'
import * as coreuiDeviceIcons from '@/../images/device_icons/geoenergy/coreui_device_icons'
import * as factory from '@/../images/device_icons/geoenergy/factory.svg'
import * as dashboardCenterIcon from '@/../images/device_icons/geoenergy/dashboard_center_icon.svg'
// import * as wallboxPlugged from '@/../images/device_icons/geoenergy/wallbox_plugged.svg'
// import * as wallboxUnplugged from '@/../images/device_icons/geoenergy/wallbox_unplugged.svg'
// import * as wallboxWarning from '@/../images/device_icons/geoenergy/wallbox_warning.svg'
import * as fuelcell from '@/../images/device_icons/geoenergy/fuelcell.svg'
// import * as generic from '@/../images/device_icons/geoenergy/generic.svg'
import * as grid from '@/../images/device_icons/geoenergy/grid.svg'
// import * as heatingelement from '@/../images/device_icons/geoenergy/heatingelement.svg'
import * as heatpump from '@/../images/device_icons/geoenergy/heatpump.svg'
import * as pv from '@/../images/device_icons/geoenergy/pv.svg'
// import * as rest from '@/../images/device_icons/geoenergy/rest.svg'
// import * as trafo from '@/../images/device_icons/geoenergy/trafo.svg'
import * as user from '@/../images/device_icons/geoenergy/user.svg'

const map = {
  // battery: battery0,
  // battery0,
  // battery20,
  // battery40,
  // battery60,
  // battery80,
  // battery100,
  chp,
  // container,
  // containerAlarm,
  // containerOk,
  // containerWarning,
  dashboardCenterIcon,
  factory,
  fuelcell,
  // generic,
  grid,
  // heatingelement,
  heatpump,
  pv,
  // rest,
  // trafo,
  user
  // wallbox: wallboxUnplugged,
  // wallboxPlugged,
  // wallboxUnplugged,
  // wallboxWarning
}

export function overwriteIcons() {
  Object.assign(ICON_MAPPING, map)
}

export function overwriteCoreuiDeviceIcons() {
  Object.assign(COREUI_DEVICE_ICON_MAPPING, coreuiDeviceIcons)
}
